import { IOfferCard } from '../../../../types';
import { sortGeo } from '../../utils';

export const prepareUnderground = ({ geo }: IOfferCard) => {
  const sortedGeoIds = geo?.sortedGeoIds || [];
  const undergrounds = geo?.undergrounds || [];

  const sortedUndergrounds = sortGeo({ sortedGeoIds, geoItems: undergrounds, sortedType: 'underground' });

  return sortedUndergrounds[0];
};
